import { JSXElement, mergeProps } from 'solid-js';
import { ConnectedAppProvider } from '~/api/types/connectedAppProviders.ts';
import { getProviderIcon } from '~/pages/ScalekitConnect/Integrations/utils.tsx';
import { twMerge } from 'tailwind-merge';

type ConnectProviderIconProps = {
  provider: ConnectedAppProvider;
  class?: string;
};

export default function ConnectProviderIcon(
  props: ConnectProviderIconProps
): JSXElement {
  const merged = mergeProps(
    {
      class: ''
    },
    props
  );
  return (
    <div class={twMerge(`max-w-[36px]`, merged.class)}>
      <img
        class={`max-w-full max-h-full`}
        src={getProviderIcon(merged.provider)}
        alt={merged.provider?.displayName}
      />
    </div>
  );
}
